import * as React from "react";
import { AlertCircle, CircleCheck, Info, TriangleAlert } from "lucide-react";

import { cn } from "../../lib/utils";

const icons = {
  error: AlertCircle,
  warning: TriangleAlert,
  info: Info,
  status: CircleCheck,
};

export const FieldFeedback = React.forwardRef(function FieldFeedback(
  { className, children, reserveSpace = false, ...props },
  ref
) {
  if (!children && !reserveSpace) return null;
  return (
    <p ref={ref} className={cn("flowpi-field-feedback", reserveSpace && "flowpi-field-feedback--reserved", className)} {...props}>
      {children}
    </p>
  );
});

export const FeedbackMessage = React.forwardRef(function FeedbackMessage(
  { className, variant = "info", title, children, ...props },
  ref
) {
  if (!children) return null;
  const Icon = icons[variant] || Info;
  return (
    <div
      ref={ref}
      role={variant === "error" ? "alert" : "status"}
      className={cn("flowpi-feedback", `flowpi-feedback--${variant}`, className)}
      {...props}
    >
      <Icon className="flowpi-feedback__icon" aria-hidden="true" />
      <div>
        {title ? <div className="flowpi-feedback__title">{title}</div> : null}
        <div>{children}</div>
      </div>
    </div>
  );
});

export function FormError(props) {
  return <FeedbackMessage variant="error" {...props} />;
}

export function WarningMessage(props) {
  return <FeedbackMessage variant="warning" {...props} />;
}

export function InfoMessage(props) {
  return <FeedbackMessage variant="info" {...props} />;
}

export function OperationNotice(props) {
  return <FeedbackMessage variant="status" {...props} />;
}
